// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #070707;
}

.badge{
  background-color: #070707;
  color: white !important;
}
.abc {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 50%;  
  background-color: black;
  color: white;
  font-weight: bold;
  min-width: 28px;
  text-align: center;
}

.badge-dot {
  position: absolute;
  top: -3px;
  right: -3px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid white;
}

.notification-list::-webkit-scrollbar {
  width: 6px;
}

.notification-list::-webkit-scrollbar-thumb {
  background-color: #d1d1d1;
  border-radius: 3px;
}

.background-grey{
  background-color: grey;
}

.dropdown-item:hover,
.dropdown-item:focus {
  background-color: #f1f1f1 !important; 
  color: #000 !important;             
}

.dropdown-menu .dropdown-item {
  cursor: default !important;
  width: 500px !important;
}

.delete-notification{
  cursor: pointer;
  background-color: black;
  color: white;
  border-radius: 14px;
}

.material-icons {
  font-size: 16px;
}

.notification-time {
  color: blue !important;
}

.close{
  cursor: pointer;
}

.dropdown-menu {
  z-index: 1050 !important; /* higher than navbar, sidebar */
  position: absolute !important;
}

div#navigation ul.navbar-nav .dropdown-menu{
  z-index: 1001;
}

@media screen and (max-width:991px){
  .navbar-collapse::after {
    position: relative;
    display: none !important;
  }
  div#navigation{
    background: transparent !important;
    order: 2 !important;
    position: absolute !important;
    width: 95% !important;
    max-width: 100%;
    margin: 0 10px !important;
  }
  .navbar .container-fluid {
    flex-direction: row !important;
    flex-wrap: nowrap !important;
}
 .navbar .navbar-wrapper {
    width: 40% !important;
    order: 1;
    z-index: 1033;
}
 .navbar .container-fluid button.navbar-toggler {
    order: 3;
    z-index: 1034;
}
div#navigation ul.navbar-nav{
  justify-content: end;
  position: unset !important;
}
div#navigation ul.navbar-nav li.nav-item.dropdown.position-static {
    display: none;
}
div#navigation ul.navbar-nav .nav-item{
  position: unset !important;
}
a#navbarDropdownMenuLink {
    text-align: end;
    padding-right: 40px;
    position: relative;
}
.navbar .notification {
    right: 33px;
}
a#navbarDropdownMenuLink i{
    font-size: 26px;
}
.navbar a.navbar-brand {
    font-size: 18px !important;
    height: auto !important;
}
div#navigation ul.navbar-nav .dropdown-menu{
  background: #fff !important;
  min-width: 100% !important;
  width: 95% !important;
  max-width: 100%;
}
div#navigation  ul.navbar-nav  .dropdown-menu {
    height: auto !important;
}
}`, "",{"version":3,"sources":["webpack://./src/app/shared/navbar/navbar.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB,EAAE,gCAAgC;EAC1D,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,kCAAkC;IAClC,mBAAmB;IACnB,6BAA6B;IAC7B,qBAAqB;IACrB,eAAe;IACf,yBAAyB;EAC3B;EACA;IACE,8BAA8B;IAC9B,4BAA4B;AAChC;CACC;IACG,qBAAqB;IACrB,QAAQ;IACR,aAAa;AACjB;CACC;IACG,QAAQ;IACR,aAAa;AACjB;AACA;EACE,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;IACI,aAAa;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;AACnB;AACA;IACI,0BAA0B;IAC1B,uBAAuB;AAC3B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;AACjB;AACA;IACI,uBAAuB;AAC3B;AACA","sourcesContent":[".icon-circle {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: #070707;\r\n}\r\n\r\n.badge{\r\n  background-color: #070707;\r\n  color: white !important;\r\n}\r\n.abc {\r\n  display: inline-block;\r\n  padding: 4px 8px;\r\n  border-radius: 50%;  \r\n  background-color: black;\r\n  color: white;\r\n  font-weight: bold;\r\n  min-width: 28px;\r\n  text-align: center;\r\n}\r\n\r\n.badge-dot {\r\n  position: absolute;\r\n  top: -3px;\r\n  right: -3px;\r\n  width: 12px;\r\n  height: 12px;\r\n  border-radius: 50%;\r\n  border: 2px solid white;\r\n}\r\n\r\n.notification-list::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.notification-list::-webkit-scrollbar-thumb {\r\n  background-color: #d1d1d1;\r\n  border-radius: 3px;\r\n}\r\n\r\n.background-grey{\r\n  background-color: grey;\r\n}\r\n\r\n.dropdown-item:hover,\r\n.dropdown-item:focus {\r\n  background-color: #f1f1f1 !important; \r\n  color: #000 !important;             \r\n}\r\n\r\n.dropdown-menu .dropdown-item {\r\n  cursor: default !important;\r\n  width: 500px !important;\r\n}\r\n\r\n.delete-notification{\r\n  cursor: pointer;\r\n  background-color: black;\r\n  color: white;\r\n  border-radius: 14px;\r\n}\r\n\r\n.material-icons {\r\n  font-size: 16px;\r\n}\r\n\r\n.notification-time {\r\n  color: blue !important;\r\n}\r\n\r\n.close{\r\n  cursor: pointer;\r\n}\r\n\r\n.dropdown-menu {\r\n  z-index: 1050 !important; /* higher than navbar, sidebar */\r\n  position: absolute !important;\r\n}\r\n\r\ndiv#navigation ul.navbar-nav .dropdown-menu{\r\n  z-index: 1001;\r\n}\r\n\r\n@media screen and (max-width:991px){\r\n  .navbar-collapse::after {\r\n    position: relative;\r\n    display: none !important;\r\n  }\r\n  div#navigation{\r\n    background: transparent !important;\r\n    order: 2 !important;\r\n    position: absolute !important;\r\n    width: 95% !important;\r\n    max-width: 100%;\r\n    margin: 0 10px !important;\r\n  }\r\n  .navbar .container-fluid {\r\n    flex-direction: row !important;\r\n    flex-wrap: nowrap !important;\r\n}\r\n .navbar .navbar-wrapper {\r\n    width: 40% !important;\r\n    order: 1;\r\n    z-index: 1033;\r\n}\r\n .navbar .container-fluid button.navbar-toggler {\r\n    order: 3;\r\n    z-index: 1034;\r\n}\r\ndiv#navigation ul.navbar-nav{\r\n  justify-content: end;\r\n  position: unset !important;\r\n}\r\ndiv#navigation ul.navbar-nav li.nav-item.dropdown.position-static {\r\n    display: none;\r\n}\r\ndiv#navigation ul.navbar-nav .nav-item{\r\n  position: unset !important;\r\n}\r\na#navbarDropdownMenuLink {\r\n    text-align: end;\r\n    padding-right: 40px;\r\n    position: relative;\r\n}\r\n.navbar .notification {\r\n    right: 33px;\r\n}\r\na#navbarDropdownMenuLink i{\r\n    font-size: 26px;\r\n}\r\n.navbar a.navbar-brand {\r\n    font-size: 18px !important;\r\n    height: auto !important;\r\n}\r\ndiv#navigation ul.navbar-nav .dropdown-menu{\r\n  background: #fff !important;\r\n  min-width: 100% !important;\r\n  width: 95% !important;\r\n  max-width: 100%;\r\n}\r\ndiv#navigation  ul.navbar-nav  .dropdown-menu {\r\n    height: auto !important;\r\n}\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
